// extracted by mini-css-extract-plugin
export default {"container":"CircularCards_container__tKM4y","content":"CircularCards_content__gsVeH","data-cards":"CircularCards_data-cards__So+Ce"};